<div class="release-notes-dialog">
    <div class="dialog-header">
        <h2 class="dialog-title">What's New</h2>
        <button class="close-btn"  (click)="close()" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-content" mat-dialog-content>
        <!-- Loading State -->
        <div *ngIf="loading" class="loading-state">
            <p>Loading...</p>
        </div>

        <!-- Single Release Note -->
        <div *ngIf="!loading && releaseNote" class="release-item current-version">
            <div class="release-header">
                <div class="version-badge current">
                    <span class="version-number">{{ releaseNote.version }}</span>
                    <span class="current-tag">Current</span>
                </div>
                <span class="release-date">{{ releaseNote.date }}</span>
            </div>

            <div class="release-description">
                <p [innerHTML]="getFormattedDescription(releaseNote.description)"></p>
            </div>
        </div>

        <!-- Error State -->
        <div *ngIf="!loading && !releaseNote" class="error-state">
            <p>No release notes available</p>
        </div>
    </div>
</div>